// extracted by mini-css-extract-plugin
export var label = "_j0-2";
export var slideContainer = "_j0-0";
export var slider = "_j0-1";